import React from 'react';
import { PiDotsThreeOutlineVertical } from 'react-icons/pi';
import ModalContainer from '../ModalContainer';
import { ThreadCardStyled, ReponseMenu, MenuBtn, StyleItem } from './ThreadCard.styles';
import DeleteThreadModal from '../DeleteProjectModal/deleteThreadModal';
import { useNavigate } from 'react-router-dom';

const ThreadCard = ({ threadCardsData, refetch }) => {
  console.log(threadCardsData);
  const navigate = useNavigate();
  return (
    <>
      {threadCardsData.map(card => (
        <ThreadCardStyled key={card?.session_id}>
          <div className="text-box">
            <ReponseMenu
              menuButton={
                <MenuBtn>
                  <PiDotsThreeOutlineVertical />
                </MenuBtn>
              }>
              {/* <ModalContainer
                width="750"
                title="Create a Project"
                content={({ onClose }) => <CreatProjectModal onClose={onClose} />}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text">Edit project</div>
                  </StyleItem>
                )}
              /> */}
              <StyleItem onClick={() => navigate(`/chat/${card?.session_id}`)}>
                <div className="text">View Chat</div>
              </StyleItem>
              <ModalContainer
                width="750"
                title="Confirm Thread Deletion"
                content={({ onClose }) => (
                  <DeleteThreadModal onClose={onClose} _id={card?.session_id} refetch={refetch} />
                )}
                btnComponent={({ onClick }) => (
                  <StyleItem onClick={onClick}>
                    <div className="text" style={{ color: 'rgba(215, 65, 32, 1)' }}>
                      Delete Thread
                    </div>
                  </StyleItem>
                )}
              />
            </ReponseMenu>
            <strong className="title" dangerouslySetInnerHTML={{ __html: card?.title }} />
            <p dangerouslySetInnerHTML={{ __html: card?.initial_message }} />
          </div>
          <div className="card-footer">
            <span className="date">
              Updated: <span dangerouslySetInnerHTML={{ __html: card?.updated_at }} />
            </span>
          </div>
        </ThreadCardStyled>
      ))}
    </>
  );
};

export default ThreadCard;
